import './blog-list.component.scss'

import customSelect from 'custom-select'
import './../../styles/modules/plugins/custom-select.scss'

const blogListEl = document.querySelector('.blog-list')
if (blogListEl) {
  const filtersEl = blogListEl.querySelector('.blog-filters select')

  customSelect(filtersEl)
}